<template>
  <div id="app">
    <div>
      <div v-if="!!num && !!idCard" class="countdown">
        {{ num }}
      </div>
      <div class="ql-container ql-snow">
        <div class="ql-editor" v-html="this.schoolConfig.notes"></div>
      </div>
      <div style="margin: 16px">
        <!-- <van-button v-if="num != 0" disabled round block type="info"
          >{{ num }}s</van-button
        > -->
        <van-button
          v-if="!!idCard"
          :disabled="num != 0"
          @click="toIndex"
          round
          block
          type="info"
          >已阅</van-button
        >
        <van-button v-else @click="toLogin" round block type="info"
          >返回登录</van-button
        >
      </div>
    </div>
  </div>
</template>
<script>
import { getSchoolConfig } from "@/api/home";
export default {
  data() {
    return {
      schoolId: 0,
      idCard: 0,
      schoolConfig: {},
      flag: true,
      num: 15,
      time: "",
      studentName: "",
    };
  },
  created() {
    this.schoolId = this.$route.query.schoolId || 0;
    this.idCard = this.$route.query.idCard || 0;
    this.studentName = this.$route.query.studentName;
    this.getSchoolConfig();
  },
  mounted() {},
  methods: {
    // 获取用户须知
    getSchoolConfig() {
      getSchoolConfig({
        schoolId: this.schoolId,
      }).then((res) => {
        this.schoolConfig = res.data.data;
        this.$toast("请详细阅读新生入学报名须知");
        setTimeout(() => {
          this.flag = false;
        }, 15000);
        this.time = setInterval(() => {
          this.numj();
        }, 1000);
      });
    },
    numj() {
      if (this.num == 0) {
        clearInterval(this.time);
        return false;
      }
      this.num--;
    },
    toIndex() {
      this.$router.push({
        path: "/index",
        query: {
          schoolId: this.schoolId,
          idCard: this.idCard,
          studentName: this.studentName,
        },
      });
    },
    toLogin() {
      this.$router.go(-1);
    },
  },
};
</script>
<style scoped>
#app {
  /* padding: 0 0.4rem; */
}
.countdown {
  position: fixed;
  z-index: 99;
  font-size: 0.37rem;
  color: #fff;
  top: 0.53rem;
  right: 0.53rem;
  display: inline-block;
  height: 0.8rem;
  width: 0.8rem;
  border-radius: 0.8rem;
  /* border:1px solid #1989fa; */
  background-color: #1989fa;
  text-align: center;
  line-height: 0.8rem;
}
</style>


// WEBPACK FOOTER //
// src/view/instructions.vue